import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";

const DashboardCard = ({ title, icon, number, route, bg }) => {
  return (
    <Link to={route}>
      <Card bg={bg} text="light">
        <Card.Header>
          <Card.Title>
            <h3 className="text-center text-white">
              {icon} {title}
            </h3>
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <h4 className="text-center text-white">{number} ລາຍການ</h4>
        </Card.Body>
      </Card>
    </Link>
  );
};

export default DashboardCard;
